var _g;

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

import * as React from "react";

function SvgProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_649_29706)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.22093 13.0758C5.38472 13.4383 4 15.0575 4 17V20H20V17C20 15.0575 18.6153 13.4383 16.7791 13.0758C16.1548 14.0202 15.3957 14.7215 14.7652 15.2003C13.9783 15.7977 12.988 16 12 16C11.012 16 10.0217 15.7977 9.23478 15.2003C8.60428 14.7215 7.84524 14.0202 7.22093 13.0758Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 7.99897C8 5.78983 9.79086 4 12 4V4C14.2091 4 16 5.78983 16 7.99897C16 8.31254 16 8.64604 16 9C16 11.2902 14.7155 12.7241 13.8275 13.4417C13.316 13.855 12.6576 14 12 14V14C11.3424 14 10.684 13.855 10.1725 13.4417C9.28448 12.7241 8 11.2902 8 9C8 8.64604 8 8.31254 8 7.99897Z",
    fill: "currentColor"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.c7bf4871a6c27402583d9854f4335267.svg";
export { ForwardRef as ReactComponent };